import React from "react";
import {
  Filter,
  TextInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  Button,
  Link,
  Create,
  List,
  DateInput,
  NumberInput,
  Datagrid,
  TextField,
  Pagination,
  DisabledInput,
  DateField,
  Edit,
  SimpleForm,
  EditButton
} from "react-admin";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import ItemSwitch from "../components/itemSwitch";
import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";
import moment from "moment";
const JacketPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const HistoryButton = props => (
  <Button
    component={Link}
    to={{
      pathname: `/item_history/jackets/${props.record.id}`
    }}
    label="Device History"
  >
    <ChatBubbleIcon />
  </Button>
);

const JacketFielter = props => (
  <Filter {...props}>
    <CustomBaseFilter label="Base Location" source="location_id" alwaysOn />
  </Filter>
);

const SwitchButton = props => {
  const rentals = props.record.number_rentals || 0;
  if (rentals > 0 && props.record.status === 1) {
    return (
      <ItemSwitch
        item={props.record}
        type={props.resource}
        history={props.history}
        location={props.location}
      />
    );
  }
  return <React.Fragment />;
};

export const JacketList = props => (
  <List
    {...props}
    resource="jackets"
    pagination={<JacketPagination />}
    filters={<JacketFielter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Jacket ID" source="id" sortable={false} />
      <TextField
        label="Last Location"
        source="location_name"
        sortable={false}
      />
      <TextField label="Jacket Model" source="model" sortable={false} />
      <TextField label="Size" source="size" sortable={false} />
      <DateField
        label="Purchase Date"
        source="purchase_date"
        sortable={false}
      />
      <EditButton />
      <HistoryButton />
      <SwitchButton {...props} />
    </Datagrid>
  </List>
);

const JacketTitle = object => (
  <span>
    {" Edit Jacket Device"} &quot;{object.record.model}&quot;
  </span>
);

const JacketCreateTitle = record => <span>Create Jacket Device</span>;

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const JacketCreate = props => (
  <Create title={<JacketCreateTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Model" source="model" />
      <TextInput label="Size" source="size" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const JacketEdit = props => (
  <Edit title={<JacketTitle />} {...props}>
    <SimpleForm>
      <DisabledInput label="Id" source="id" />
      <TextInput label="Model" source="model" />
      <TextInput label="Size" source="size" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/jackets.js